/* eslint-disable no-console */
import React from 'react';
import {
  number,
  required,
  dynamicMobileValidation,
  auMobValidation
} from '../../utils/validation/index';
import { Field, formValueSelector, change } from 'redux-form';
import PropTypes from 'prop-types';
import { FORMNAME_APPLICANT_DETAILS, OTP_WAIT_TIME } from '../../utils/constants';
import {
  getPhoneValidationsByCountry,
  sendOtpOnMobile,
  verifyMobileOtp
} from '../../redux/actions/otp-request/otp-request-action';
import { connect } from 'react-redux';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { updateScreenConfig } from '../../redux/actions/user-flow/user-flow-action';
import { normalizeAll, r_maxLength, r_onlyNumbers } from '../../utils/validation/restrictions';
import { applicantDetailsSubmit } from '../../redux/actions/corporate-user-flow/corporate-user-flow-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import BoxDropdown from '../../components/form-controls/outlinedDropdown';
import { API_URL } from '../../utils/config';
import MobileTextField from './mobileTextField';
import styled from 'styled-components';
import './mobile-verification.css';
import { FLOW_TYPE_ONBOARDING, OTP_VERIFIED } from '../../utils/constants/eventsConstants';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import CommonButton from '../common-button/CommonButton';
import { logEvent } from '../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../utils/events/eventsConstants';
import { DEVICES } from '@Commons';

const MobileVerificationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 30px;
  @media only screen and (max-width: 500px) {
    margin-left: ${(props) => props.countryCode === 'IN' && '20px'};
  }
  .heading {
    display: flex;
    p {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 20px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: ${COLORS.black};
      width: 100%;
      margin-left: ${(props) => (props.countryCode === 'IN' ? '0px' : '10px')};
    }
    @media only screen and (max-width: 1080px) {
      p {
        width: 305px;
        margin-left: 10px;
      }
      align-items: center;
    }
     @media ${DEVICES.tab} {
      margin-left: ${(props) => (props.countryCode === 'HK' ? '48px' : '0')} !important;
    }
  }

  .mobileContentWrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    @media only screen and (max-width: 1080px) {
      width: 100%;
      flex-direction: column;
      align-items: center;
      margin-left: 10px;
    }
  }
  .mobileBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .innerPart {
      width: 319px;
      display: flex;
      .numberField {
        margin-right: 10px;

        i {
          font-size: 1em;
          margin-left: -8px;
        }
      }
      @media only screen and (max-width: 1080px) {
        width: 318px;
      }
    }
    @media only screen and (max-width: 1080px) {
      width: 100%;
      z-index: 1;
    }
  }
  .number {
    margin-top: 8px;
    width: 318px;
    input[type='search'],
    input[type='text'] {
      color: ${(p) => (p.diableMobileNumberField ? '#a4a5b1' : '#000000')};
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }

  .sendCodeButton {
    margin-top: 6px;
    border-radius: 5px;
    border: none;
    background-color: ${COLORS.brandSecondary};
    width: 220px;
    height: 40px;
    font-weight: bold;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.13px;
    text-align: center;
    color: ${COLORS.black};
    margin-left: 72px;
    @media only screen and (max-width: 1080px) {
      margin-left: 30%;
    }
  }
  .verificationBox {
    width: 77%;
    margin-top: 10px;
    @media only screen and (max-width: 1080px) {
      width: 100%;
    }
  }
  #otpError {
    color: #f44336;
    margin-left: 14px;
    font-size: 10px;
    line-height: normal;
  }
`;

class MobileVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mob_code: 'Code',
      countdown: OTP_WAIT_TIME,
      inline: null,
      sent: 0,
      counter: 0,
      otpSent: false,
      showEdit: false
    };
    this.timeout = null;
    this.inputRef = null;
  }

  getInputRef = (ref) => (this.inputRef = ref);

  init = async (countryCode) => {
    let { getPhoneValidationsByCountry, mobile_country_code, is_phone_verified, isSignUpView } =
      this.props;
    let response = await getPhoneValidationsByCountry(countryCode, isSignUpView);
    if (response && response.data && response.data.success) {
      this.phoneCode = response.data.data[0].phone_code[0];
      this.setState({ mob_code: `+${response.data.data[0].phone_code[0]}` });
    } else if (mobile_country_code) {
      this.setState({ mob_code: `+${response.data.data[0].phone_code[0]}` });
    }

    if (is_phone_verified) {
      this.setState({
        inline: `${this.inputRef?.childNodes?.[0]?.value || 'your number'} has been verified`
      });
    }
  };

  isMobileValid = () => {
    let { formSyncErrors } = this.props;
    return !(formSyncErrors && formSyncErrors.mobile_number);
  };

  sendOTP = async () => {
    let { activateLoader, mobile_country_code, disableLoader, showMessage, sendOtpOnMobile } =
      this.props;
    if (!this.isMobileValid()) return;
    try {
      activateLoader();
      let response = await sendOtpOnMobile({
        mobile_country_code: mobile_country_code || this.phoneCode,
        mobile_number: this.inputRef?.childNodes?.[0]?.value,
        is_send_otp: true
      });
      disableLoader();
      if (response && response.data && response.data.success) {
        await new Promise((resolve) =>
          this.setState({ otpSent: true, counter: this.state.counter + 1 }, resolve)
        );
        this.setTimeout();
        await new Promise((resolve) =>
          this.setState(
            {
              inline: `Enter the code you received on ${
                this.inputRef?.childNodes?.[0]?.value || 'your number'
              }`
            },
            resolve
          )
        );
      }
    } catch (e) {
      disableLoader();
      console.error(e);
      showMessage({ text: [JSON.stringify(e)], type: 'error' });
    }
    await new Promise((resolve) => this.setState({ otpSent: false }, resolve));
  };

  resendOTP = async () => {
    if (!this.isMobileValid()) return;
    try {
      await new Promise((resolve) =>
        this.setState({ otpSent: true, counter: this.state.counter + 1 }, resolve)
      );
      const sendOtpOnMobileObj = {
        mobile_country_code: this.phoneCode,
        mobile_number: this.inputRef?.childNodes?.[0]?.value,
        is_send_otp: true
      };
      if (this.state.counter >= 3) sendOtpOnMobileObj.is_send_otp = false;
      let response = await this.props.sendOtpOnMobile(sendOtpOnMobileObj);
      if (response && response.data && response.data.success) this.setTimeout();
      await new Promise((resolve) =>
        this.setState(
          {
            inline: `A new verification code has been sent to ${
              this.inputRef?.childNodes?.[0]?.value || 'your number'
            }`
          },
          resolve
        )
      );
    } catch (e) {
      console.error(e);
      this.props.showMessage({ text: [JSON.stringify(e)] }, 'error');
    }
    await new Promise((resolve) => this.setState({ otpSent: false }, resolve));
  };

  setTimeout = () => {
    if (this.timeout) {
      clearInterval(this.timeout);
      this.timeout = null;
    }
    if (this.state.counter < 4)
      this.timeout = setInterval(() => {
        let newVal = this.state.countdown - 1 || OTP_WAIT_TIME;
        if (newVal === OTP_WAIT_TIME) {
          this.setState({ showEdit: true });
          clearInterval(this.timeout);
          this.timeout = null;
        }
        this.setState({ countdown: newVal || OTP_WAIT_TIME });
      }, 1080);
  };

  onMobileCountryCodeChange = async (obj, isSignUpView) => {
    const { dispatch, formName } = this.props;
    if (isSignUpView && obj) {
      dispatch(change(formName, 'mobile_number', ''));
      await this.init(obj.country_code);
    }
    obj &&
      (await this.setState({
        mob_code: '+' + obj.code,
        country_code: obj.country_code
      }));
  };

  onOTPChange = async (e) => {
    let { mobile_number, mobile_country_code, countryCode, formName, verifyMobileOtp, dispatch } =
      this.props;
    if (e.target.value.length === 6) {
      let result = await verifyMobileOtp(
        e.target.value,
        mobile_number,
        mobile_country_code,
        countryCode,
        {
          formID: 'personal-detail-mobile-verify'
        }
      );
      if (result) {
        logEvent(OTP_VERIFIED, FLOW_TYPE_ONBOARDING, {}, LOG_TYPE.CLEVER_TAP);
        if (formName === FORMNAME_APPLICANT_DETAILS) {
          dispatch(
            applicantDetailsSubmit({
              mobile_number,
              mobile_country_code,
              country_of_residence: countryCode
            })
          );
        }
        this.setState({
          inline: `${this.inputRef?.childNodes?.[0]?.value || 'your number'} has been verified`
        });
        this.props.updateScreenConfig('mobile_verification', {
          is_required: false
        });
      } else await this.setState([{ inline: 'You have entered an incorrect verification code' }]);
    }
  };

  otpValidation = (value) => {
    let error = number(value);
    return error;
  };

  async componentDidMount() {
    let { countryCode } = this.props;
    countryCode && (await this.init(countryCode));
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    let { countryCode, isSignUpView } = nextProps;
    if (!isSignUpView) {
      nextProps.countryCode &&
        nextProps.countryCode !== this.props.countryCode &&
        (await this.init(countryCode));
    }
  }

  clearTimeOut = async () => {
    if (this.timeout) {
      await clearInterval(this.timeout);
    }
    this.timeout = null;
    await this.setState({ countdown: OTP_WAIT_TIME, counter: 0, inline: null });
    this.props.dispatch(change(this.props.formName, 'mobile_otp', ''));
  };

  setEdit = async () => {
    this.setState({ showEdit: false });
  };

  render() {
    const {
      is_phone_verified,
      disablePinVerification,
      isSignUpView,
      mobile_country_code,
      countryCode,
      formSyncErrors
    } = this.props;

    let mobileNumberCheck = formSyncErrors && formSyncErrors.mobile_number ? false : true;

    const diableMobileNumberField =
      is_phone_verified === true || this.timeout !== null || this.state.showEdit ? true : false;

    const { otpSent, counter, countdown, inline, country_code } = this.state;
    let mobileCountryCodeURL = isSignUpView
      ? `${API_URL}/public/country/phone-code?concat_phone_country_code=true`
      : `${API_URL}/country/phone-code?country_code=${countryCode}`;
    let tooltip =
      countryCode === 'US'
        ? {
            tooltip:
              // eslint-disable-next-line max-len
              'We do not accept registrations using Non-Fixed VOIP phone numbers. Accounts and transactions created with Non-Fixed VOIP phone numbers may be rejected by Instarem'
          }
        : {};

    return (
      <MobileVerificationWrapper
        id="mobileVerify"
        countryCode={countryCode}
        diableMobileNumberField={diableMobileNumberField}
      >
        <div className="heading">
          <p>{'Contact'}</p>
        </div>
        <div className="mobileContentWrapper">
          <div className="mobileBox">
            <div className="innerPart">
              <div className="numberField">
                <Field
                  bindToThisObject={mobile_country_code}
                  dependedOnObject={isSignUpView ? null : countryCode}
                  name="mobile_country_code"
                  type="text"
                  disabled={is_phone_verified}
                  preselect_and_disable_if_one_item={true}
                  validate={[required]}
                  component={BoxDropdown}
                  width="90px"
                  placeholder={'Code'}
                  isSearchable={isSignUpView}
                  isCompact={isSignUpView}
                  className={'theme-dropdown'}
                  url={mobileCountryCodeURL}
                  onDropdownChange={(obj) => this.onMobileCountryCodeChange(obj, isSignUpView)}
                  emptyOnNotFound
                  selectedLabel={this.state.mob_code}
                />
              </div>
              <div className="number">
                <Field
                  name="mobile_number"
                  type="text"
                  component={MobileTextField}
                  countryCode={countryCode}
                  clearTimeOut={this.clearTimeOut}
                  disablePinVerification={disablePinVerification}
                  showEdit={this.state.showEdit}
                  setEdit={this.setEdit}
                  is_phone_verified={is_phone_verified}
                  validate={
                    country_code === 'AU' || (!country_code && countryCode === 'AU')
                      ? [auMobValidation, dynamicMobileValidation]
                      : [dynamicMobileValidation]
                  }
                  normalize={(() => {
                    let restrictions = [],
                      { mobileValidationReducer } = this.props;
                    if (mobileValidationReducer) {
                      if (mobileValidationReducer.type === 'startsWithFour')
                        restrictions.push(r_onlyNumbers);
                      if (mobileValidationReducer.length) {
                        let { max, exact } = mobileValidationReducer.length;
                        restrictions.push(r_maxLength(exact || max));
                      }
                      if (mobileValidationReducer.type === 'number')
                        restrictions.push(r_onlyNumbers);
                      if (mobileValidationReducer.length) {
                        let { max, exact } = mobileValidationReducer.length;
                        restrictions.push(r_maxLength(exact || max || 50));
                      }
                    }
                    return normalizeAll(restrictions);
                  })()}
                  placeholder={`${isSignUpView ? "Applicant's " : ''}Mobile number`}
                  disabled={is_phone_verified || this.timeout || this.state.showEdit}
                  className={`input mobile-number ${isSignUpView ? '' : 'form-flow'}`}
                  {...tooltip}
                  tip={this.state.inline || ''}
                  getInputRef={this.getInputRef}
                />
                {!is_phone_verified && this.props.showMobileOtpBox && mobileNumberCheck ? (
                  <p id="otpError">OTP verification mandatory</p>
                ) : null}
              </div>
            </div>
          </div>
          {!disablePinVerification && (
            <div className="verificationBox">
              {!is_phone_verified && inline && this.isMobileValid() && (
                <Field
                  name="mobile_otp"
                  type="text"
                  styleCheck="verify"
                  className="input form-flow mobile-number enter-mob-otp"
                  component={MobileTextField}
                  placeholder={'Enter 6 digit Code'}
                  validate={this.otpValidation}
                  normalize={r_maxLength(6)}
                  onChange={this.onOTPChange}
                  resendOtp={this.resendOTP}
                  countdown={countdown}
                  counter={counter}
                  inline={this.state.inline}
                  tip={
                    this.isMobileValid() && !is_phone_verified && this.timeout && counter < 3
                      ? `Request a new verification code after ${countdown} seconds`
                      : ''
                  }
                />
              )}
              {(() => {
                if (
                  !this.inputRef?.childNodes?.[0]?.value ||
                  !this.isMobileValid() ||
                  otpSent ||
                  this.timeout ||
                  is_phone_verified
                )
                  return null;
                switch (counter) {
                  case 0:
                    return !this.state.showEdit ? (
                      <CommonButton
                        type="button"
                        text="Send verification code"
                        width={250}
                        height={50}
                        onClick={(e) => {
                          e.preventDefault();
                          this.sendOTP();
                        }}
                        id="send-mob-verification"
                      />
                    ) : null;
                  default:
                    return null;
                }
              })()}
            </div>
          )}
        </div>
      </MobileVerificationWrapper>
    );
  }
}

MobileVerification.propTypes = {
  is_phone_verified: PropTypes.bool,

  getPhoneValidationsByCountry: PropTypes.func,
  sendOtpOnMobile: PropTypes.func,
  verifyMobileOtp: PropTypes.func,
  parent: PropTypes.any,
  showMessage: PropTypes.func,
  countryCode: PropTypes.string,
  updateScreenConfig: PropTypes.func,
  handleOtpFieldClick: PropTypes.func,
  disableHeader: PropTypes.bool,
  mobileValidationReducer: PropTypes.object,
  formSyncErrors: PropTypes.object,
  mobile_country_code: PropTypes.any,
  mobile_number: PropTypes.string,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  disablePinVerification: PropTypes.bool,
  showMobileOtpBox: PropTypes.bool,
  isSignUpView: PropTypes.bool,
  dispatch: PropTypes.any,
  formName: PropTypes.any
};

const mapStateToProps = (reduxState, ownProps) => {
  const {
    rootReducer: {
      userStatusReducer: { is_phone_verified },
      mobileValidationReducer
    }
  } = reduxState;

  const formValues = formValueSelector(ownProps.formName);
  const { mobile_number, mobile_country_code } = formValues(
    reduxState,
    'mobile_number',
    'mobile_country_code'
  );

  return {
    is_phone_verified,
    mobile_number,
    mobile_country_code,
    mobileValidationReducer
  };
};

//Connect form to react-redux
const reactReduxMobileVerification = connect(mapStateToProps, {
  showMessage,
  sendOtpOnMobile,
  verifyMobileOtp,
  getPhoneValidationsByCountry,
  updateScreenConfig,
  activateLoader,
  disableLoader
})(MobileVerification);

export default reactReduxMobileVerification;
